import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/PageTitle';
import withUser from '../../hoc/withUser';
import Table from '../../components/Table';
import { getColumnForDevicesTable } from './devicesColumns';
import { useStore } from '../../store';
import '../../components/Table/styles.scss';
import TableContainer from '../../components/TableContainer';
import { ReactComponent as DeleteIcon } from '../../assets/delete_black.svg';

import { toJS } from 'mobx';
import Modal from '../../components/Modal';

const DevicesPage = observer(({ user, authToken }) => {
  const {
    rootStore: {
      profileStore,
      profileStore: { devicesStore },
    },
  } = useStore();
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [remount, setRemount] = useState(null);

  useEffect(() => {
    devicesStore.loadingDevices = true;
    const getUserDevices = async () => {
      if (!profileStore.profileData) {
        await profileStore.initProfile(user, authToken, i18n);
      }

      await devicesStore.getUserDevices(user.sub);
    };

    getUserDevices().then(() => (devicesStore.loadingDevices = false));

    return () => devicesStore.resetUserDevices();
  }, [devicesStore, authToken, i18n, profileStore, user, remount]);

  const handleDeleteUserDevice = async () => {
    await devicesStore.deleteDevice(toJS(selectedDevice.value), t);
    setShowModal(false);
    setRemount(prev => !prev);
  };

  const cellActionDropdown = device => {
    return (
      <button
        className="action-wrapper"
        onClick={() => {
          setSelectedDevice(device);
          setShowModal(true);
        }}
      >
        <DeleteIcon />
      </button>
    );
  };

  return (
    <TableContainer>
      <PageTitle titleKey="devicesPage.title" subtitleKey="devicesPage.subtitle" />
      <Table
        isTableLoading={devicesStore.loadingDevices}
        data={devicesStore.devices || []}
        columns={getColumnForDevicesTable(t, cellActionDropdown) || []}
        totalRowsFromDatabase={devicesStore.devices.length}
        loadTableData={devicesStore.getUserDevices}
      />
      <Modal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setSelectedDevice(null);
        }}
        onConfirm={handleDeleteUserDevice}
        title={t('devicesPage.modal.title')}
        description={t('devicesPage.modal.description')}
        confirmButtonTitle={t('devicesPage.modal.confirmButtonTitle')}
        cancelButtonTitle={t('devicesPage.modal.cancelButtonTitle')}
        disabledConfirmButton={!selectedDevice}
      />
    </TableContainer>
  );
});

export default withUser(DevicesPage);
